import { formatDurationToHHMMSS } from '@lib/utils/units';
import css from './TimestampOverlay.module.scss';

interface TimestampOverlayProps {
  duration?: number;
  show?: boolean;
}

export const TimestampOverlay = ({ duration, show = true }: TimestampOverlayProps) => {
  if (!show || !duration) {
    return null;
  }

  return (
    <span className={`${css.duration}`}>
      <span>{formatDurationToHHMMSS(duration)}</span>
    </span>
  );
};
